import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthUser } from '../contexts/auth-context-type';
import { LoadingSpinner } from '../loading-spinner/loading-spinner';
import { AuthStatusEnum } from '@employ-engage/data';
import { useCurrentCompany } from '../contexts';

export interface AuthGateProps {
  children: ReactNode;
}

export const AuthGate = ({ children }: AuthGateProps) => {
  const { user, status } = useAuthUser();
  const { currentCompany } = useCurrentCompany();
  const { pathname } = useLocation();

  if (status === AuthStatusEnum.Unauthenticated) {
    return <Navigate to="/" state={{ from: pathname }} replace />;
  }

  if (status === AuthStatusEnum.Pending) {
    return <LoadingSpinner spinnerId="auth-gate-loading" />;
  }

  if (pathname.startsWith('/undefined') || pathname.split('/').length <= 2) {
    return <Navigate to="/" state={{ from: pathname }} replace />;
  }

  if (
    status !== AuthStatusEnum.Authenticated &&
    pathname.split('/')[1] === 'admin'
  ) {
    return <Navigate to="/" state={{ from: pathname }} replace />;
  } else if (status === AuthStatusEnum.Authenticated && user) {
    if (pathname === '/') {
      return <Navigate to={`/${currentCompany.id}/admin`} replace />;
    }
    if (
      pathname === `/${currentCompany.id}/admin` &&
      currentCompany?.orgTreeNextLevelKeys?.length === 1 &&
      currentCompany?.managementRoles?.length === 0
    ) {
      return <Navigate to={`/${currentCompany.id}/admin/settings`} replace />;
    }
  }

  return children;
};
